import { render, staticRenderFns } from "./UiAlert.vue?vue&type=template&id=6c89d645"
import script from "./UiAlert.vue?vue&type=script&lang=js"
export * from "./UiAlert.vue?vue&type=script&lang=js"
import style0 from "./UiAlert.vue?vue&type=style&index=0&id=6c89d645&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports